export default __webpack_public_path__ + "static/media/ogrod.65b4480d.svg";